/**
 * Debug utility to check if Firebase environment variables are loaded
 * Call this in browser console: window.checkFirebaseConfig()
 */
export const checkFirebaseConfig = () => {
  const config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };

  console.log('Firebase Configuration Check:');
  console.log('==========================');
  
  const missing: string[] = [];
  const configured: string[] = [];

  Object.entries(config).forEach(([key, value]) => {
    if (!value || value.includes('YOUR_')) {
      missing.push(key);
      console.log(`❌ ${key}: NOT SET`);
    } else {
      configured.push(key);
      // Show first/last few chars for security
      const masked = value.length > 10 
        ? `${value.substring(0, 4)}...${value.substring(value.length - 4)}`
        : '***';
      console.log(`✅ ${key}: ${masked}`);
    }
  });

  console.log('==========================');
  
  if (missing.length === 0) {
    console.log('✅ All Firebase environment variables are configured!');
    return true;
  } else {
    console.warn(`⚠️ Missing ${missing.length} environment variable(s):`, missing);
    console.warn('Make sure:');
    console.warn('1. Your .env file exists in the project root');
    console.warn('2. All variables start with REACT_APP_');
    console.warn('3. You have restarted the dev server (npm start)');
    return false;
  }
};

// Make it available globally for debugging
if (typeof window !== 'undefined') {
  (window as any).checkFirebaseConfig = checkFirebaseConfig;
}



